<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:98%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
			
				<div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 2vh;"
				
				>	
                  <div style="height: 35px;width:100px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==0?'#3c9cff':'#d9ecff',color:type==0?'white':'#409eff'}" @click="show=true"
                    >
                        {{ "添加星姬天" }}
                    </div>
				</div>

				<div style="height: auto;flex:1;" >
				<el-table
					height="80vh"
				    :data="list"
					border
				    style="width: 100%"
					>
				    <el-table-column
				      label="昵称"
                      prop="name"
                      >
				    </el-table-column>   
                    <el-table-column
					      fixed="right"
					      label="操作"
						  width="180"
					      >
					      <template slot-scope="scope">
							<el-button @click="deletexjt(scope.row)" type="text" size="small">删除</el-button>
					      </template>
					</el-table-column>
				  </el-table>
				</div>
			</div>
		</div>
        <el-dialog title="添加星姬天" :visible.sync="show">
            <el-form :model="form">
                <el-form-item label="昵称">
                <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="newxjt">确 定</el-button>
            </div>
        </el-dialog>
		
	</div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
        list:[],
        fileList:[],
        type:0,
        show:false,
        form:{
            name:""
        }
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {

	getmore(){
		post("/api/getuserlist",{}).then((res)=>{
			if(res.data.code==1001){
                this.list=res.data.data;
            }
		})
	},
    newxjt(e){
        post("/api/admin/newxjt",{name:this.form.name}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    image: res.data.msg,
                    type: 'success'
                });
                this.form.name='';
                this.show=false;
                this.getmore();
            }else{
                this.$notify({
                    title: '错误',
                    image: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    },
    deletexjt(e){
        post("/api/admin/deletexjt",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    image: res.data.msg,
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    image: '未知的系统错误',
                    type: 'error'
                });
            }
		})
    }
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>